module.exports = __webpack_public_path__ + "media/cheer.70955135.mp3";